import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';

import { PlanPickerComponent } from '../../shared/plan-picker/plan-picker.component';
import { ProductOrderDowngradeGuard } from './guards/product-order-downgrade.guard';
import { ProductOrderParamsGuard } from './guards/product-order-params.guard';
import { ProductOrderPaymentStepGuard } from './guards/product-order-payment-step.guard';
import { ProductOrderBillingStepComponent } from './product-order-billing-step/product-order-billing-step.component';
import { DowngradeViewTexts } from './product-order-downgrade-step/downgrade-view-texts';
import { ProductOrderDowngradeStepComponent } from './product-order-downgrade-step/product-order-downgrade-step.component';
import { DowngradeTextsToken } from './product-order-downgrade-step/product-order-downgrade.types';
import { ProductOrderParameterizedComponent } from './product-order-parameterized/product-order-parameterized.component';
import { ProductOrderPaymentStepComponent } from './product-order-payment-step/product-order-payment-step.component';
import { ProductOrderDefaultStep, ProductOrderStepUrl } from './product-order.types';
import { ProductOrderComponent } from './product-order/product-order.component';

export const ROUTES: Route[] = [
  {
    path: '',
    component: ProductOrderComponent,
    children: [
      {
        path: ProductOrderStepUrl.ProductPicker,
        component: PlanPickerComponent,
      },
      {
        path: ':productId/:slots/:interval',
        component: ProductOrderParameterizedComponent,
        canActivate: [ProductOrderParamsGuard],
        canActivateChild: [ProductOrderDowngradeGuard],
        providers: [
          {
            provide: DowngradeTextsToken,
            useValue: DowngradeViewTexts,
          },
        ],
        children: [
          {
            path: ProductOrderStepUrl.Downgrade,
            component: ProductOrderDowngradeStepComponent,
          },
          {
            path: ProductOrderStepUrl.OrderBilling,
            component: ProductOrderBillingStepComponent,
          },
          {
            path: ProductOrderStepUrl.OrderPayment,
            canActivate: [ProductOrderPaymentStepGuard],
            component: ProductOrderPaymentStepComponent,
          },
        ],
      },
    ],
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: ProductOrderDefaultStep,
  },
];

@NgModule({
  imports: [RouterModule.forChild(ROUTES)],
})
export class ProductOrderRoutingModule {}
